import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import RoleGuard from '../guards/RoleGuard';

import ConfigPrecios from '../pages/ConfigPrecios';
import Horarios from '../pages/operaciones/Horarios';
import Terminales from '../pages/operaciones/Terminales';
import Usuarios from '../pages/Usuarios';
import Salidas from '../pages/operaciones/Salidas';
import Reportes from '../pages/Reportes';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import ValidarBoleto from '../pages/escaner/ValidarBoleto';
import NotificacionesFlotante from '../components/NotificacionesFlotante.js';
import { useAuth } from '../context/AuthContext';

// Wrapper interno para acceder al contexto de auth
// (NotificacionesFlotante solo se monta para staff, no para choferes ni sin login)
const AdminConNotificaciones = () => {
  const { user } = useAuth();
  const esStaff = user?.rol === 'super_admin' || user?.rol === 'admin_sucursal';

  return (
    <>
      <Routes>
        <Route path="login" element={<Login />} />

        {/* 🔒 Rutas admin y super admin */}
        <Route element={<RoleGuard allowedRoles={['super_admin', 'admin_sucursal']} />}>
          <Route path="precios" element={<ConfigPrecios />} />
          <Route path="horarios" element={<Horarios />} />
          <Route path="terminales" element={<Terminales />} />
          <Route path="salidas" element={<Salidas />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="usuarios" element={<Usuarios />} />
        </Route>

        {/* 🔒 Rutas compartidas: admins + chofer */}
        <Route element={<RoleGuard allowedRoles={['super_admin', 'admin_sucursal', 'chofer']} />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="validar-boleto" element={<ValidarBoleto />} />
        </Route>

        <Route path="/" element={<Navigate to="dashboard" replace />} />
      </Routes>

      {/* Notificaciones flotantes — solo para super_admin y admin_sucursal */}
      {esStaff && <NotificacionesFlotante />}
    </>
  );
};

const AdminRutas = () => {
  return (
    <AuthProvider>
      <AdminConNotificaciones />
    </AuthProvider>
  );
};

export default AdminRutas;